import { Modal } from 'antd';
import { useState } from 'react';

import { useDeleteProgramMutation, useGetProgramQuery } from '~/api/ProgramAPI';
import { Text16 } from '~/styles/Texts';

interface Props {
  programId: string;
  deleteModalOpen: boolean;
  setDeleteModalOpen: (deleteModalOpen: boolean) => void;
}

const DeleteModal = ({ programId, deleteModalOpen, setDeleteModalOpen }: Props) => {
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);

  const { data } = useGetProgramQuery(programId);
  const [deleteProgram] = useDeleteProgramMutation();

  const handleDelete = async () => {
    setIsConfirmLoading(true);

    await deleteProgram(programId);

    setIsConfirmLoading(false);
    setDeleteModalOpen(false);
  };

  return (
    <Modal
      title="프로그램 삭제"
      open={deleteModalOpen}
      confirmLoading={isConfirmLoading}
      onOk={() => handleDelete()}
      onCancel={() => setDeleteModalOpen(false)}
    >
      <Text16>타이틀: {data?.title}</Text16>
    </Modal>
  );
};

export default DeleteModal;
